module.exports = "/work-site/img/moment.d80e2747.png";